import activity from './activity.fr-CA.json';
import assets from './assets.fr-CA.json';
import auth from './auth.fr-CA.json';
import commissions from './commissions.fr-CA.json';
import common from './common.fr-CA.json';
import dashboard from './dashboard.fr-CA.json';
import payouts from './payouts.fr-CA.json';
import profile from './profile.fr-CA.json';
import rewards from './rewards.fr-CA.json';
import shareLink from './shareLink.fr-CA.json';
import stats from './stats.fr-CA.json';

const fr_CA = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  shareLink,
  stats,
};

export default fr_CA;
